<div class="flex flex-row w-full flex-center items-center gap-3">
  <mat-icon class="error-icon" color="primary">error_outline</mat-icon>
  <div class="flex flex-col gap-2 error-message" *transloco="let t">
    @if (data.status) {
      <span
        [innerHtml]="t('error.error_' + data.status, { SEPARATOR: '<br />', prefix: '<b>', suffix: '</b>' }) | safeHtml"
      ></span>
    } @else {
      <span [innerHtml]="t('error.message', { SEPARATOR: '<br />', prefix: '<b>', suffix: '</b>' }) | safeHtml"></span>
    }

    @if (data?.message) {
      <span [innerHtml]="t('error.' + data.message, { SEPARATOR: '<br />' }) | safeHtml"></span>
    }
  </div>
</div>
<span matSnackBarActions>
  <button mat-button type="button" aria-label="Close" (click)="close()" class="pr-1 min-w-8">
    <mat-icon color="primary">close</mat-icon>
  </button>
</span>
